'use strict';

module Patersons {

    export class ClientConfigService extends BaseService {
       
        getAdviser() {
            return this.get("/dataService/api/adviser");
        };

        getChangeRequestCount() {
            return this.get("/dataService/odata/changeRequests/ChangeRequestService.GetChangeRequestsForApprovalCount");
        }
    }
}